import { wrapperBuilder } from './build';

wrapperBuilder
  .getVariablesRegisterInstance()
  .addVariable('deviceNotificationsToken', {
    startValue: undefined,
    persist: false,
  });
